import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React, { useCallback } from 'react';
import { EventType } from '@atlassianlabs/jql-editor-common';
import { Action, ActionSubject } from '../../../../analytics';
import { useAutocompleteLoading, useAutocompleteOptions, useStoreActions } from '../../../../state';
import AutocompleteDropdown from '../autocomplete-dropdown';
var Autocomplete = function Autocomplete(_ref) {
  var keymap = _ref.keymap,
    onClick = _ref.onClick;
  var _useAutocompleteOptio = useAutocompleteOptions(),
    _useAutocompleteOptio2 = _slicedToArray(_useAutocompleteOptio, 1),
    options = _useAutocompleteOptio2[0];
  var _useAutocompleteLoadi = useAutocompleteLoading(),
    _useAutocompleteLoadi2 = _slicedToArray(_useAutocompleteLoadi, 1),
    loading = _useAutocompleteLoadi2[0];
  var _useStoreActions = useStoreActions(),
    _useStoreActions2 = _slicedToArray(_useStoreActions, 2),
    createAndFireAnalyticsEvent = _useStoreActions2[1].createAndFireAnalyticsEvent;
  var handleClick = useCallback(function (option, analyticsAttributes) {
    onClick(option);
    createAndFireAnalyticsEvent({
      action: Action.SELECTED,
      actionSubject: ActionSubject.AUTOCOMPLETE_OPTION,
      eventType: EventType.TRACK,
      attributes: _objectSpread({}, analyticsAttributes)
    });
  }, [createAndFireAnalyticsEvent, onClick]);
  return /*#__PURE__*/React.createElement(AutocompleteDropdown, {
    options: options,
    loading: loading,
    keymap: keymap,
    onClick: handleClick
  });
};
export default Autocomplete;